import React, { useEffect, useState } from 'react'
import { Box, SwipeableDrawer, IconButton, Tooltip } from '@mui/material'
import * as OnboardEntity from '../../Entities/OnBoardingContainerTypes'
import { useForm } from 'react-hook-form'
import Textarea from 'src/Common/ui/textArea'
import { useRiskStore } from './Store/RiskStore'
import { cn } from 'src/lib/utils'
import { Button } from 'src/Common/ui/button'
import { IoIosCloseCircleOutline } from 'react-icons/io'

export default function CommentsDrawer ({ setEditState, handleReject, editState, comments, setComments, loading, title }) {
    const { RiskDetailsById } = useRiskStore()
    const { errors, control } = useForm()
    const userDepartment = localStorage.getItem('department')
    useEffect(() => {
        if (editState.right) {
            if (RiskDetailsById.riskInformation.department === userDepartment) {
                setComments(RiskDetailsById?.riskInformation?.raisedRemarks)
            } else {
                setComments(RiskDetailsById?.riskInformation?.ownerRemarks)
            }
        }
    }, [editState])
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
            event.type === OnboardEntity.KEYDOWN &&
            (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }
        setEditState({ ...editState, [anchor]: open })
    }
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const [ isSubmitDisabled, setIsSubmitDisabled ] = useState(true) // Initially disabled

    const onInputChange = (e) => {
        setComments(e)
    }

    useEffect(() => {
        // If comments are empty, disable submit
        if (!comments || comments.trim().length === 0) {
            setIsSubmitDisabled(true)
        } else {
            setIsSubmitDisabled(comments.trim().length < 2)
        }
    }, [comments])

    const handleCancel = () => {
        setEditState({ right: false })
        setComments('')
    }
    return (
        <div>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 3, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState?.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <Box className="p-6 flex justify-between items-center border-b-2 border-[hsl(var(--primary-table-head))]">
                    <h2 className="text-2xl text-primary font-semibold">{title}</h2>
                    <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <IconButton onClick={() => handleCancel()} aria-label="close">
                            <IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' />
                        </IconButton>
                    </Tooltip>
                </Box>
                <div className='p-6'>
                    <Textarea className={cn('ml-[0px]')} label="Comments" value={comments === 'undefined' ? '' : comments || '' }
                        onValueChange={(e) => onInputChange(e)}
                        defaultValue={comments} type="text" placeholder="Enter Comments" name="ImpactOfRisk" errors={errors} control={control} />
                </div>

                <div className='absolute bottom-[16px] right-[20px]'>
                    <div className="flex justify-end space-x-4">
                        <Box>
                            <Button onClick={() => handleCancel()}
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                disabled={loading}
                            >
                         Cancel
                            </Button>
                        </Box>
                        <Box>
                            <Button onClick={() => handleReject(RiskDetailsById?.riskInformation?.level1 === 3 && RiskDetailsById?.riskInformation?.level2 === 8 ? 'Risk [ID] has been rejected' : 'Risk [ID] has been denied')}
                                disabled={loading || isSubmitDisabled}
                            >
                         Submit
                            </Button>
                        </Box>
                    </div>
                </div>
                <div className='p-4 flex flex-col gap-3'>

                </div>

            </SwipeableDrawer>
        </div>
    )
}
